
    // IMPORTS
    import { defineComponent, PropType } from 'vue'

    export default defineComponent({
        name: 'loadSpinner',

        components: {},

        props: {
            size: {
                type: String as PropType<string>, // Accept percentage like '50%' or pixel values like '64px'
                required: false,
                default: () => '64px', // Default to pixel-based size for backward compatibility
                validator: (value: string) => {
                    // Regular expression to check if the value is a valid number, 'px', or '%'
                    const regex = /^(\d+(\.\d+)?)(px|%)?$/
                    return regex.test(value)
                }
            }
        },

        setup() {
            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const computedData = {}

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...computedData }
        }
    });
